
import { OrdersReplacementApiRemoteService } from '../../Services/api/orders-replacement/orders-replacement-service'
import { IOrderReplacementEntity, IPayloadOrderReplacement } from '../../Services/api/orders-replacement/orders-replacement.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowOrdersReplacementUseCase
implements IFormUsecase<string, IOrderReplacementEntity> {
  constructor (private readonly OrdersReplacementApi: OrdersReplacementApiRemoteService) {}
    
  public async handle (
    id: string
  ): Promise<Result<IOrderReplacementEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrdersReplacementApi.show(id)

      if (response.isFailure) {
        return response
      }

    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
